export const gridColumns = [
  {
    key: 'name',
    size: 1.5,
    minWidth: 200,
  },
  {
    key: 'alias',
    size: 1.5,
    minWidth: 100,
  },
  {
    key: 'domains',
    size: 2,
    minWidth: 200,
  },
  {
    key: 'actions',
    size: 2,
    minWidth: 200,
  },
]
